import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import LandingFooter from '@/modules/Pages/shared/LandingFooter';
import LandingNav from '@/modules/Pages/shared/LandingNav';
import '@/modules/Pages/shared/landingPage.css';
import { trackLandingViewOnce } from '@/utils/funnel/waitlistFunnel';
import { AppRoutes } from '@/utils/routes/router';

import EarlyAccessSection from './sections/EarlyAccessSection';
import HeroSection from './sections/HeroSection';
import MechanismSection from './sections/MechanismSection';
import ProblemSection from './sections/ProblemSection';
import ProofSection from './sections/ProofSection';
import ReframeSection from './sections/ReframeSection';
import TransformationSection from './sections/TransformationSection';

/**
 * Product homepage — structure from "ChurnSignal - homepage" copy doc.
 */
export default function HomePage() {
  const navigate = useNavigate();
  const goToWaitlist = useCallback(() => {
    navigate(AppRoutes.waitlist);
  }, [navigate]);

  useEffect(() => {
    trackLandingViewOnce('/');
  }, []);

  return (
    <div className="landing-page landing-grain min-h-screen font-sans relative">
      <div className="relative z-10">
        <LandingNav onWaitlistClick={goToWaitlist} ctaLabel="Join the waitlist" />
        <main>
          <HeroSection onApplyClick={goToWaitlist} />
          <ProblemSection onApplyClick={goToWaitlist} />
          <ReframeSection />
          <MechanismSection />
          <TransformationSection />
          <ProofSection />
          <EarlyAccessSection onApplyClick={goToWaitlist} />
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
